import { Component, OnInit } from '@angular/core';
import { StepTemplateBaseComponent } from 'app/core/components/dynamic-onboarding/step-template-base/step-template-base.component';
import { Observable } from 'rxjs/Observable';
import { ConfigService } from 'app/core/services/config.service';
import { RequestService } from 'app/core/services/request.service';
import { ChildState } from 'app/core/components/dynamic-onboarding/dynamic-onboarding.component';
import { DynamicOnboardingService } from '../dynamic-onboarding.service';
import { AmberApi } from 'app/core/models/api-helpers';
import { FormGroup, FormBuilder } from '@angular/forms';

@Component({
  selector: 'itpx-branding-card',
  templateUrl: './branding-card.component.html',
  styleUrls: ['./branding-card.component.css']
})
export class BrandingCardComponent extends StepTemplateBaseComponent {

  private form: FormGroup;

  constructor(
    private configService: ConfigService,
    private requestService: RequestService,
    private service: DynamicOnboardingService,
    private fb: FormBuilder
  ) {
    super();
  }

  ngOnInit() {
    // let logo$ = this.parentForm.get('domain').valueChanges.bindToLifecycle(this);
    // let watermark$ = this.parentForm.get('watermark').valueChanges.bindToLifecycle(this);

    this.form = this.fb.group({
      domain:[this.parentForm.get('domain').value]
    })
    this.next.bindToLifecycle(this).filter(value => this.id === value).subscribe(_ => {
      // let watermark$: Observable<any>;
      let observables$: Observable<any>[] = [];
      if (this.parentForm.get('watermark').dirty && this.parentForm.get('watermark').value.trim() || this.parentForm.get('logo').dirty) {
        // let domainDTO = { ...this.parentForm.get('organisationDetails').value };
        let body = {
          watermark: this.parentForm.get('watermark').value.trim(),
          path: this.parentForm.get('logo').value
        }
        observables$.push(this.editBranding(body)
          .map(response => {
            this.parentForm.get('organisationDetails').setValue(response.data);
            this.parentForm.get('watermark').markAsPristine();
            this.parentForm.get('logo').markAsPristine();
          })
          .catchAndEmit('error'));
      }
      // else
      //   watermark$ = Observable.of({});
      if (this.form.get('domain').dirty && this.form.get('domain').value.trim()) {
        // let domainDTO = this.parentForm.get('organisationDetails').value;
        let body = { name: this.form.get('domain').value.trim(), isDefault: true };
        observables$.push(this.addAlternativeDomain(body, this.parentForm.get('organisationDetails').value.id)
          .map(response => {
            this.parentForm.get('domain').setValue(response.data.name);
            this.form.get('domain').markAsPristine();
          })
          .catchAndEmit('error'));
        // .switchMap(_ => this.service.getOrganizationDetails())
      }
      if (0 === observables$.length)
        this.status.emit(ChildState.done);
      // else {
      //   domain$ = Observable.of({});
      // }
      // domain$.bindToLifecycle(this)
      //   .filter(obj => !(Object.keys(obj).length === 0 && obj.constructor === Object))
      //   .subscribe(response => this.parentForm.get('organisationDetails').setValue(response.name), _ => 'error');
      // watermark$.bindToLifecycle(this) //.catchAndEmit('error')
      //   .filter(obj => !(Object.keys(obj).length === 0 && obj.constructor === Object))
      //   .extract(AmberApi.Data)
      //   .subscribe(response => this.parentForm.get('organisationDetails').setValue(response), _ => 'error');

      Observable.zip(...observables$).bindToLifecycle(this)
        // .reduce((acc, curr) => acc.concat(curr), [])
        .subscribe(emitted => {
          this.status.emit(!emitted.some(resp => resp === 'error') ? ChildState.done : ChildState.error);
        });
    });

    this.status.emit(ChildState.enabled); //Enable next button
  }

  coverLogoDetails(details: any) {
    // console.log(details);
    this.parentForm.get('logo').setValue(details);
    this.parentForm.get('logo').markAsDirty();
  }

  private editBranding(details: any): Observable<any> {
    let url = this.configService.get('server').url +
      this.configService.get('endpoints').organization.organizationDetails.editBranding.api;
    return this.requestService.post(url, details);
  }

  addAlternativeDomain(details: any, domainId: any) {
    let url =
      this.configService.get('server').url +
      this.configService.get('endpoints').organization.domain.addAlternative.api + '/' + domainId;
    return this.requestService.post(url, details);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/dynamic-onboarding/branding-card/branding-card.component.ts